import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Email from '../../domain/Email';
import Locale from '../../domain/Locale';
import Color from '../../domain/Color';
import Password from '../../domain/Password';
import Message from './../Message';
import Alert from './../Alert';
import MarkdownComponent from './../MarkdownComponent';
import SocialLogins from '../SocialLogins';
import { props } from 'tcomb-react';
import t from 'tcomb-form';

const FormType = t.struct({
  email: Email,
  password: Password
});

const value = process.env.NODE_ENV !== 'production' ?
  {
    email: 'verified@domain.com',
    password: 'verified'
  } :
  {};

@props({
  locale: Locale,
  message: t.maybe(t.ReactElement),
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  goResendPassword: t.Func,
  doLogin: t.Func,
  goFacebookLogin: t.Func,
  goGoogleLogin: t.Func,
  goTwitterLogin: t.Func,
  goMicrosoftLogin: t.Func,
  goRegister: t.maybe(t.Func)
})
export default class Login extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {
      options: this.getOptions()
    };
  }

  getOptions() {
    const bundle = get_bundle(this.props.locale).login;
    return {
      fields: {
        email: {
          label: bundle.email
        },
        password: {
          type: 'password',
          label: bundle.password
        }
      }
    };
  }

  getSxContent() {
    const bundle = get_bundle(this.props.locale).login;
    return (
      <div className="left-image">
        <div className="left-claim">
          <div className="cell">
            <MarkdownComponent>{bundle.claim.title}</MarkdownComponent>
          </div>
          <div className="cell">
            <MarkdownComponent>{bundle.claim.remember}</MarkdownComponent>
          </div>
          <div className="cell">
            <MarkdownComponent>{bundle.claim.call_to_action}</MarkdownComponent>
          </div>
        </div>
      </div>
    );
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    var value = this.refs.form.getValue();
    if (value) {
      this.props.doLogin(value.email, value.password);
    }
  }

  goResendPassword = (evt) => {
    evt.preventDefault();
    this.props.goResendPassword();
  }

  getDefaultMessage() {
    return (<Message bgColor={this.props.themeBgColor} fontColor={this.props.themeBgFontColor}>{get_bundle(this.props.locale).login.title}</Message>);
  }

  getMessage() {
    if ( this.props.message ) {
      return this.props.message;
    }

    return this.getDefaultMessage();
  }

  getAlert() {
    if (!this.props.message) {
      return null;
    }

    return (
      <Alert type="warning">
        <MarkdownComponent>{ get_bundle(this.props.locale).login.warning }</MarkdownComponent>
      </Alert>
    );
  }

  render() {

    const { locale } = this.props;
    const bundle = get_bundle(locale).login;
    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };
    return (
      <div id="login" className="cols">
        <div className="large-100">
          <div className="cols">
            <div className="large-60 small-hide ">
              <div className="cell">
                { this.getSxContent() }
              </div>
            </div>
            <div className="large-40 large-pull-right small-100">
              <div className="cell">
                <div id="login_actions">
                  { this.getMessage() }
                  <div id="form" className="box light">
                    <form onSubmit={this.onSubmit}>
                      <t.form.Form
                        ref="form"
                        type={FormType}
                        options={this.state.options}
                        value={value} />
                      <p><a href="#" id="go_resend_password" onClick={this.goResendPassword}>{bundle.go_resend_password}</a></p>
                      <button id="do_login" className="btn" style={btnStyle}>{bundle.do_login}</button>
                    </form>
                  </div>
                  <SocialLogins
                    title={bundle.other_logins}
                    goFacebook={this.props.goFacebookLogin}
                    goGoogle={this.props.goGoogleLogin}
                    goTwitter={this.props.goTwitterLogin}
                    goMicrosoft={this.props.goMicrosoftLogin} />
                  {this.getAlert()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/content/Login.js
 **/